<template>
  <div id="app" style="height: 100%;width: 100%;">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
  	var e = sessionStorage.getItem('navColor')
    var l = sessionStorage.getItem('leftNavColor')
    if(e!=null){
      this.$store.state.mainPort.style.navColor = e
      this.$store.state.mainPort.style.leftNavColor = l
      $('#ChangeCss').attr('href','static/css/ChangeCss/'+e+'.css') 
    }else{
      this.$store.state.mainPort.style.navColor = 'green'
      this.$store.state.mainPort.style.leftNavColor = 'site-menubar-light'
      $('#ChangeCss').attr('href','static/css/ChangeCss/'+this.$store.state.mainPort.style.navColor+'.css') 
    }

  }
}
</script>

<style lang="less">
.btn-select{
      border: 1px solid #e4eaec;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue